import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import SearchPage from './SearchPage';

const CategoryPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  // For now, redirect to search page with category filter
  // In a full implementation, we would get category ID from slug
  return <div dir="rtl" lang="fa"><SearchPage /></div>;
};

export default CategoryPage; 
